<template>
	<Accordion
		:title="title"
		:showClear="selection !== ''"
		@clear="clearFilter"
	>
		<template #content>
			<ClientOnly>
				<component
					v-if="filterComponent"
					:is="filterComponent"
				/>
			</ClientOnly>
		</template>
		<template #footer>
			<a class="Selection">{{ selection }}</a>
		</template>
	</Accordion>
</template>

<script setup lang="ts">
import Accordion from '@components/Accordion/Accordion.vue';
import { FilterType } from '@domain/enums/FilterType';
import { useSearchStore } from '@app/stores/useSearchStore';
import { useRouter } from 'vue-router';
import { type Component, PropType } from 'vue';

const router = useRouter();

const props = defineProps({
	title: {
		type: String,
		required: true,
	},
	selection: {
		type: String,
		required: true,
	},
	filterType: {
		type: String as PropType<FilterType>,
		required: true,
	},
	filterComponent: {
		type: Object as PropType<Component>,
		default: null,
	},
});

const clearFilter = (): void => {
	const searchStore = useSearchStore();

	searchStore.removeFilterByType(props.filterType, router);
};
</script>

<style scoped lang="scss">
	.Selection {
		display: -webkit-box;
		-webkit-line-clamp: 2;
		line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
		word-break: break-word;
		color: $Grey-700;
		user-select: none;

		@include TextStyle(BodyMediumRegular);
	}
</style>
